<div class="floorplan-viewer">
  <div #canvasContainer class="canvas-container"></div>

  @if (isLoading) {
    <div class="loading-overlay">
      <div class="loading-content">
        <div class="spinner"></div>
        <span class="loading-text">Loading 3D Model...</span>
      </div>
    </div>
  }

  @if (loadError) {
    <div class="error-overlay">
      @if (canViewInAR) {
        <span class="material-icons info-icon">view_in_ar</span>
        <span class="error-text">{{ loadError }}</span>
        <button class="action-btn ar-btn error-ar-btn" (click)="viewInAR()">
          <span class="material-icons ar-icon">view_in_ar</span>
          View in AR
        </button>
        @if (isIOS) {
          <button class="action-btn error-scan-btn" (click)="onCreateFloorplan()">
            <span class="material-icons scan-icon">sensor_occupied</span>
            Scan Again
          </button>
        }
      } @else {
        <span class="material-icons error-icon">error_outline</span>
        <span class="error-text">{{ loadError }}</span>
      }
    </div>
  }

  @if (!isLoading && !loadError) {
    <div class="floorplan-actions-bar">
      @if (canViewInAR) {
        <button class="action-btn ar-btn" (click)="viewInAR()">
          <span class="material-icons ar-icon">view_in_ar</span>
          View in AR
        </button>
      }
      @if (isIOS) {
        <button class="action-btn" (click)="onCreateFloorplan()">
          <span class="material-icons scan-icon">sensor_occupied</span>
          Scan
        </button>
      }
      @if (isDemo) {
        <button class="action-btn" (click)="onUploadFloorplan()">Upload</button>
      }
    </div>
  }

</div>
